import BaseService from "../baseService";
class Contabilizar extends BaseService {
  constructor(id) {
    const resource = "nfe-ncm/contabilizar";
    let relationship = {};
    super(id, relationship, resource);
  }
}

export default (id) => new Contabilizar(id);
